export const randomInteger = (min, max) => {
  return Math.round(Math.random() * (max - min) + min)
}

export const allUppercase = (text) => {
  if (text) {
    return text.toUpperCase()
  }
  return ''
}

export const randomPercentagePair = (total) => {
  let data = []

  for (let i = 0; i < total; i++) {
    const randomInt = randomInteger(40, 60)

    data[i] = [randomInt, 100 - randomInt]
  }

  return data
}

export const arrayOfRandomInt = (total, min, max) => {
  return Array(total)
    .fill()
    .map((x) => randomInteger(min, max))
}

export const arrayOfColors = () => {
  return [
    '#f44336', // red
    '#9c27b0', // purple
    '#2196f3', // blue
    '#cddc39', // lime
    '#673ab7', // deep-purple
    '#ffeb3b', // yellow
    '#e91e63', // pink
    '#009688', // teal
    '#4caf50', // green
    '#8bc34a', // light-green
    '#3f51b5', // indigo
    '#ff5722', // deep-orange
    '#ffc107', // amber
    '#ff9800' // orange
  ]
}

export const getImgUrl = (pic) => {
  try {
    return require('@/assets/' + pic)
  } catch (e) {
    console.log(e)
    return ''
  }
}
